import * as React from "react";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Slider from "@mui/material/Slider";
import Typography from "@mui/material/Typography";
import { TitleInformationContainer } from "./LoanCalculator.styles";
import constants from "../../constants";
import axios from "axios";

import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";

function valuetext(value) {
  return `${value}°C`;
}

const LoanCalculatorForm = () => {
  const [loanType, setLoanType] = React.useState("HOME");
  const [interestRate, setInterestRate] = React.useState(6.15);
  const [loanAmount, setLoanAmount] = React.useState(250000);
  const [loanTenure, setLoanTenure] = React.useState(1);
  const [maxLoanTenure, setMaxLoanTenure] = React.useState(30);
  const [loanEMI, setLoanEMI] = React.useState("");
  const [loanEMIError, setLoanEMIError] = React.useState("");

  const personalMarksWithoutCollateral = [
    {
      value: 1,
      label: "1",
    },
    {
      value: 5,
      label: "5",
    },
  ];

  const personalMarks = [
    {
      value: 1,
      label: "1",
    },
    {
      value: 10,
      label: "10",
    },
  ];
  const homeMarks = [
    {
      value: 1,
      label: "1",
    },
    {
      value: 30,
      label: "30",
    },
  ];
  const investMarks = [
    {
      value: 1,
      label: "1",
    },
    {
      value: 7,
      label: "7",
    },
  ];

  const [marks, setMarks] = React.useState(homeMarks);

  const handleChange = (event) => {
    setLoanType(event.target.value);
    if (event.target.value === "PERSONAL") {
      setMaxLoanTenure(10);
      setMarks(personalMarks);
      if (loanTenure > 10) {
        setLoanTenure(10);
      }
    } else if (event.target.value === "HOME") {
      setMaxLoanTenure(30);
      setMarks(homeMarks);
    } else if (event.target.value === "INVESTMENT") {
      setMaxLoanTenure(7);
      setMarks(investMarks);
      if (loanTenure > 7) {
        setLoanTenure(7);
      }
    } else if (event.target.value === "PERSONALWC") {
      setMaxLoanTenure(5);
      setMarks(personalMarksWithoutCollateral);
      if (loanTenure > 5) {
        setLoanTenure(5);
      }
    }
    axios.get(constants.LOAN_RATE_API + event.target.value).then((response) => {
      setInterestRate(response.data.data[0].INTEREST_RATE);
    });
  };
  const handleAmountChange = (event) => {
    var input = event.target.value;
    input = input.toString().replaceAll(",", "");
    var nf = new Intl.NumberFormat();
    var num = nf.format(input);
    setLoanAmount(num);
  };

  const handleSliderChange = (event, value) => {
    setLoanTenure(value);
  };

  const handleCalculateEMI = () => {
    var input = parseInt(loanAmount.toString().replaceAll(",", ""));
    var reqData = { loanType, loanAmount: input, loanTenure };
    axios.post(constants.CALCULATE_EMI_API, reqData).then((response) => {
      if (response.data.success === true) {
        setLoanEMI(response.data.message);
        setLoanEMIError("");
      } else {
        setLoanEMIError(response.data.message);
        setLoanEMI("");
      }
    });
  };

  return (
    <>
      <TitleInformationContainer>Loan Calculator</TitleInformationContainer>
      <Grid container spacing={4}>
        <Grid item xs={12} sm={6}>
          <FormControl variant="filled" fullWidth>
            <InputLabel
              id="loan-type"
              style={{
                color: "#CD9D2F",
              }}
            >
              I would like to*
            </InputLabel>
            <Select
              labelId="loan-type"
              id="loan-type-select"
              value={loanType}
              onChange={handleChange}
              style={{
                borderBottom: "1px solid #000",
              }}
            >
              <MenuItem
                value={"PERSONALWC"}
                style={{
                  color: "#000",
                }}
              >
                Personal Loan (Without Collateral)
              </MenuItem>
              <MenuItem
                value={"PERSONAL"}
                style={{
                  color: "#000",
                }}
              >
                Personal Loan
              </MenuItem>
              <MenuItem
                value={"HOME"}
                style={{
                  color: "#000",
                }}
              >
                Real Estate Loan
              </MenuItem>
              {/* <MenuItem value={"INVESTMENT"}>Investment Backed Loan</MenuItem> */}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            id="interest-rate"
            name="interest-rate"
            label={
              <Typography
                style={{
                  color: "#CD9D2F",
                }}
              >
                Interest Rate %
              </Typography>
            }
            fullWidth
            value={interestRate}
            autoComplete="interest-rate"
            variant="filled"
            style={{
              borderBottom: "1px solid #000",
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography
            id="discrete-slider-always"
            style={{
              color: "#000",
            }}
            gutterBottom
          >
            Terms of repayment (years)
          </Typography>
          <br />
          <br />
          <Slider
            defaultValue={1}
            getAriaValueText={valuetext}
            max={maxLoanTenure}
            min={1}
            aria-labelledby="discrete-slider-always"
            step={1}
            onChange={handleSliderChange}
            marks={marks}
            value={loanTenure}
            valueLabelDisplay="on"
            style={{
              color: "#CD9D2F",
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            id="loan-amount"
            name="loan-amount"
            label={
              <Typography
                style={{
                  color: "#CD9D2F",
                }}
              >
                Loan Amount (MUR)
              </Typography>
            }
            fullWidth
            value={loanAmount}
            onChange={handleAmountChange}
            autoComplete="loan-amount"
            variant="filled"
            error={loanEMIError}
            style={{
              borderBottom: "1px solid #000",
              marginTop: -10,
            }}
          />
          <div
            style={{
              fontSize: "14px",
              color: "#FF0000",
              fontWeight: "bold",
              width: "100%",
            }}
          >
            {loanEMIError}
          </div>
        </Grid>
      </Grid>
      <br />
      <br />
      <br />
      <Grid container spacing={1}>
        <Grid item xs={12} sm={12}>
          <center>
            <div
              style={{
                fontSize: "30px",
                color: "#000",
                fontWeight: "bold",
                width: "100%",
              }}
            >
              {loanEMI}{" "}
            </div>
          </center>
        </Grid>
        <Typography
          style={{
            fontSize: "10px",
            color: "#000",
            marginBottom: "25px",
          }}
        >
          The loan calculator is an indicative tool only and displays minimum
          interest rates for each product. All figures obtained via the
          calculator are for your general information and provide an estimated
          guide to loan repayments. This simulation and the resulting
          calculations do not constitute a loan application or offer. Swan
          Capital Solutions is not responsible for any discrepancies arising
          from any use of or reliance upon any calculations or conclusions
          reached using the loan calculator. Terms & conditions, fees, charges,
          and credit criteria apply and may result in a different comparison
          rate. You are recommended to talk to our financing specialists before
          making any final decision to ensure your unique needs and financial
          requirements have been considered.
        </Typography>
        <Grid item xs={12} sm={12}>
          <center>
            <Button
              className="btn-swan-calculate"
              variant="contained"
              onClick={handleCalculateEMI}
              style={{
                padding: "20px 40px",
                display: "table",
                width: "auto",
                backgroundColor: "#CD9D2F",
                margin: "0 auto",
              }}
            >
              CALCULATE MONTHLY REPAYMENT
            </Button>
          </center>
        </Grid>
      </Grid>
    </>
  );
};

export default LoanCalculatorForm;
